module.exports = "query DueTomorrowIssuesCountQuery{dueTomorrow:issues(closedAt_Isnull:true,dueTomorrow:true){totalCount hasUnreadMessages}}"